<template>
  <form-group class="ma-0 pa-0">
    <v-row justify="start">
      <v-col cols="4">
        <check-icon
          id="input:validatedDocument"
          v-model="payload.validatedDocument"
          :label="setLabel('validatedDocument', 'Documento', 'validado')"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="4">
        <check-icon
          id="input:validatedFacade"
          v-model="payload.validatedFacade"
          :label="setLabel('validatedFacade', 'Fachada')"
          :loading="isLoading"
        />
      </v-col>
      <v-col cols="4">
        <check-icon
          id="input:validatedSelfie"
          v-model="payload.validatedSelfie"
          :label="setLabel('validatedSelfie', 'Selfie')"
          :loading="isLoading"
        />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';

export default {
  name: 'DocumentsValidateDataView',
  components: { FormGroup },
  props: {
    value: {
      type: Object,
      default() {
        return {
          validatedDocument: '',
          validatedFacade: '',
          validatedSelfie: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    payload() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
    hasProperty() {
      return (key) => this.payload[key];
    },
    setLabel() {
      return (property, label, replace = '') => (this.hasProperty(
        property,
      ) ? `${label} ${replace || 'validada'}`
        : `${label} não ${replace || 'validada'}`);
    },
  },
};
</script>
